import { validateSchema } from '../validateSchema'
import { snippetSchema } from './snippetSchema'

export const validateSnippet = (data: Object) => {
  return validateSchema(data, snippetSchema)
}
